import http from "../utils/http";
import notify from "../utils/notifications";


export const getNotasOferta = async (oferta_id) => {
    try {
        const res = await http.get(`/contratos/notas`, {
            params: {
                oferta_id,
            },
        });
        return res.data;
    } catch (err) {
        notify.error(err, "Error al obtener las notas de la oferta.");
        return [];
    }
};

export const createNotaOferta = async (oferta_id, note_text) => {
    try {
        const res = await http.post(`/contratos/notas`, {
            oferta_id,
            note_text
        });
        notify.success("Nota creada correctamente");
        return res.data;
    } catch (err) {
        notify.error(err, "Error al crear la nota");
        throw err;
    }
};

